import { useMemo } from "react";
import { useOpenedFolder } from "../../../hooks/use-opened-folder";


export function useParentFolder() {
    const { openedFolder } = useOpenedFolder();

    const parent = useMemo(() => {
        if (openedFolder) {
            return openedFolder.result;
        } return null;
    }, [openedFolder]);

    return parent;
}
